import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 21, viewBox: "0 0 11 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.5 2L1.70711 9.79289C1.31658 10.1834 1.31658 10.8166 1.70711 11.2071L9.5 19", stroke: "white", strokeWidth: 2.2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
